import axios from "../axios"

//分页查找视频
export const findAllVideo = (data) => {
    return axios({
		url: '/api/video/findAll',
		method: 'get',
		params: data
    })
};


//查找视频详情
export const findVideo = (data) => {
    return axios({
		url: '/api/video/find',
		method: 'get',
		params: data
    })
};

//分页查找文件
export const findAllFile = (data) => {
    return axios({
		url: '/api/file_management/findAll',
		method: 'get',
		params: data
    })
};

//查找文件详情
export const findFile = (data) => {
    return axios({
		url: '/api/file_management/find',
		method: 'get',
		params: data
    })
};


// WEBPACK FOOTER //
// ./src/http/moudules/video.js